<template>
  <div class="project">
    <div class="item" v-for="(item,i) in list" :key="i" @click="$router.push(`/project/${item.id}`)">
      <img :src="`${options.cdn}/${item.image}`"/>
      <div class="title">{{item.title}}</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'project',
    data() {
      return {
        list: []
      }
    },
    computed: {
      ...mapState(['options'])
    },
    async mounted () {
      this.list = await this.axios('/project')
    }
  }
</script>

<style lang="stylus" scoped>
  .project
    padding 0 20px

    .item
      cursor pointer

      img
        width 100%

      .title
        margin-top 20px
        margin-bottom 30px
        font-family 'NeutraText-BoldItalicAlt'
        font-size 2.6rem

  @media screen and (min-width: 769px)
    .item
      .title
        margin-left 50px
</style>
